let radioButton = [...document.querySelectorAll('.p-top-reserve__radio')];
let forms = [...document.querySelectorAll('form[class^=p-top-reserve__form]')];

for (let i = 0; i < radioButton.length; i++) {
  radioButton[i].addEventListener('change', () => {
    classRemove(forms);
    forms[i].classList.add('is-current');
  })
}

// headerのフォーム
let headerRadioButton = [...document.querySelectorAll('.l-header__reserve-radio')];
let headerForms = [...document.querySelectorAll('form[class^=l-header__form]')];

for (let i = 0; i < headerRadioButton.length; i++) {
  headerRadioButton[i].addEventListener('change', () => {
    classRemove(headerForms);
    headerForms[i].classList.add('is-current');
  })
}

// 客室詳細
let roomRadioButton = [...document.querySelectorAll('.p-room-lower-reserve__radio')];
let roomForms = [...document.querySelectorAll('form[class^=p-room-lower-resrve__form]')];

for (let i = 0; i < roomRadioButton.length; i++) {
  roomRadioButton[i].addEventListener('change', () => {
    classRemove(roomForms);
    roomForms[i].classList.add('is-current');
  })
}


function classRemove(element){
  element.forEach((form) => {
    form.classList.remove('is-current');
  })
}


// 多言語
let globalFormTab = [...document.querySelectorAll('.p-top-reserve__radio-group:not(:lang(ja)) li')];

globalFormTab.forEach((tab) => {
  tab.addEventListener('click', () => {
    classRemove(globalFormTab);
    tab.classList.add('is-current');
  })
})